(function($) {
  'use strict';
  var $searchToolbarBtns = $('button.search-toolbar__btn');
  var $dropdownBtns = $searchToolbarBtns.not('.search-toolbar__toggle');
  $searchToolbarBtns.each(function() {
    var $btn = $(this);
    $btn.on('click', function() {
      var expanded = $btn.attr('aria-expanded') === 'true';
      $dropdownBtns.attr('aria-expanded', 'false');
      $btn.attr('aria-expanded', `${!expanded}`);
    });
  });
  $(document).on('keydown', function(event) {
    // ESC key
    if (event.which === 27) {
      $dropdownBtns.attr('aria-expanded', 'false');
    }
  }).on('click', function(event) {
      if (!event.target.closest('.search-toolbar__dropdown, .search-toolbar__btn')) {
        $dropdownBtns.attr('aria-expanded', 'false');
      }
    });
})(jQuery);
